export const environment = {
    authApiUrl: `https://api.${window.location.hostname}/auth`,
    envName: "test",
    isLocalToServer: false
  };
